import { render, staticRenderFns } from "./VarietyGridTemplate.vue?vue&type=template&id=766ee4c6&scoped=true"
import script from "./VarietyGridTemplate.vue?vue&type=script&lang=js"
export * from "./VarietyGridTemplate.vue?vue&type=script&lang=js"
import style0 from "./VarietyGridTemplate.vue?vue&type=style&index=0&id=766ee4c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766ee4c6",
  null
  
)

export default component.exports